module.exports = __webpack_public_path__ + "img/usa-football-ico.802bcebf.png";